import type { To } from 'history';
import React from 'react';

import UnpluggedImage from '@/assets/images/unplugged.png';
import { ButtonLink } from '@/components/Button';

interface Props {
  title: string;
  description: string;
  image?: React.ReactNode;
  buttonTo: To;
  buttonLabel: string;
}

const _ErrorPage: React.FC<Props> = ({
  title,
  description,
  image,
  buttonTo = '/',
  buttonLabel = '처음으로',
}) => {
  return (
    <section className="flex items-center justify-center w-full h-[100vh] pb-10">
      <div className="w-2/3 lg:w-1/2 mx-auto space-y-10">
        {image ? (
          <div className="flex justify-center">{image}</div>
        ) : (
          <img src={UnpluggedImage} alt={title} className="mx-auto" />
        )}

        <div className="text-center">
          <h1 className="text-[32px] font-semibold">{title}</h1>
          <p
            className="mt-4 whitespace-pre-line"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </div>

        <div className="w-full md:w-40 mx-auto">
          <ButtonLink variant="solid" to={buttonTo}>
            {buttonLabel}
          </ButtonLink>
        </div>
      </div>
    </section>
  );
};

export default _ErrorPage;
